import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mav-table-icon',
  templateUrl: './table-icon.component.html',
  styleUrls: ['./table-icon.component.scss']
})
export class TableIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
